import { ItemList } from 'orm'
import { map } from 'lodash'

class BrandList extends ItemList {
    getEntityKey() {
        return "admin/brand"
    }

    getAsOptions() {
        const items = this.getVisibleObjects()
        return map(items, function(item) {
          return { label: item.name, value: item.id }
        }
      )
    }
}

export const adminBrandList = new BrandList("admin_brand__default")
export const adminBrandAutoCompleteList = new BrandList("admin_brand_auto_complete__default")
